import classNames from 'classnames';
import React from 'react';

const FormGroup = ({ label, htmlFor, isRequired, isValid, validationMessage, showValidation, children }) => {
    const className = classNames({
        'form-group': true,
        'has-error': !isValid && showValidation,
    });
    return (
        <div className={className}>
            {label && (
                <label htmlFor={htmlFor}>
                    {label}
                </label>
            )}
            {isRequired && <span className="input-required"> *</span>}
            {children}
            {!isValid && showValidation && (
                <span className="help-block error-state">{validationMessage}</span>
            )}
        </div>
    );
};

export default FormGroup;
